import { Button, Grid, Typography, Box } from '@mui/material'
import { styled } from '@mui/system'
import * as Sentry from '@sentry/react'
import processConcurCallback from 'api/concur'
import { login } from 'api/user'
import OcrReaderLogo from 'assets/images/logoSl.svg'
import { LINK_SUPPORT } from 'config'
import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import LoginLayout from './LoginLayout'

const GridContainer = styled(Grid)({
  height: '100vh',
})

const LbSidebar = styled(Grid)(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  backgroundColor: 'rgb(5, 214, 134)',
  color: '#ffffff',
  overflow: 'hidden',
  position: 'relative',
  width: '100%',
  paddingRight: '15px',
  paddingLeft: '15px',
}))

const LbContent = styled(Grid)(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  backgroundColor: '#fff',
  color: '#888888',
  overflow: 'hidden',
  position: 'relative',
  width: '100%',
  paddingRight: '15px',
  paddingLeft: '15px',
}))

const Logo = styled(Box)({
  width: '100%',
  maxWidth: '330px',
  height: '50px',
  overflow: 'hidden',
  backgroundColor: 'transparent',
  backgroundImage: `url("${OcrReaderLogo}")`,
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'contain',
})

const LbMessage = styled(Typography)({
  width: '240px',
  minHeight: '60px',
  overflow: 'hidden',
  fontSize: '17.5px',
  lineHeight: '1.9em',
  letterSpacing: '0.03em',
  marginTop: '40px',
  marginBottom: '1rem',
})

const LbInstruction = styled('div')(() => ({
  width: '100%',
  minHeight: '180px',
  overflow: 'hidden',
  fontSize: '16px',
  lineHeight: '1.7em',
  letterSpacing: '0.02em',
  textAlign: 'center',
}))

const BtnSecondary = styled(Button)({
  boxShadow: 'none',
  textTransform: 'none',
  fontSize: '16px',
  fontWeight: 550,
  padding: '6px 12px',
  border: '1px solid',
  lineHeight: 1.5,
  backgroundColor: 'rgb(5, 214, 134)',
  borderColor: 'rgb(5, 214, 134)',
  fontFamily: [
    '-apple-system',
    'BlinkMacSystemFont',
    '"Segoe UI"',
    'Roboto',
    '"Helvetica Neue"',
    'Arial',
    'sans-serif',
    '"Apple Color Emoji"',
    '"Segoe UI Emoji"',
    '"Segoe UI Symbol"',
  ].join(','),
  '&:hover': {
    backgroundColor: 'rgb(5, 214, 134)',
    borderColor: 'rgb(5, 214, 134)',
    boxShadow: 'none',
  },
  '&:active': {
    boxShadow: 'none',
    backgroundColor: '#0062cc',
    borderColor: '#005cbf',
  },
  '&:focus': {
    boxShadow: '0 0 0 0.2rem rgba(0,123,255,.5)',
  },
})

const ConcurLogin: React.FC = () => {
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    void processConcurCallback(location)
  }, [location])

  const handleLoginClick = async () => {
    try {
      const { loginUrl } = await login()
      window.location.href = loginUrl
    } catch (err) {
      Sentry.captureException(err)
      navigate('failure')
    }
  }
  const toSupportPage = () => {
    window.location.href = LINK_SUPPORT
  }

  return (
    <LoginLayout>
      <GridContainer container>
        <LbSidebar item sm={5} xl={5}>
          <Logo />
          <LbMessage variant="body1">
            LINE WORKS OCR Reader
            <br />
            ご利用ありがとうございます
          </LbMessage>
        </LbSidebar>
        <LbContent item sm={7} xl={7}>
          <LbInstruction>
            <Typography variant="body1" sx={{ marginBottom: (theme) => theme.spacing(2) }}>
              ご契約・セットアップ済のお客様は、
              <br />
              こちらからログインして接続してください
              <br />
              ログインすると、自動的にSAP Concurと連携されます
            </Typography>
            <BtnSecondary variant="contained" disableRipple onClick={() => void handleLoginClick()}>
              ビジネスIDでログイン
            </BtnSecondary>
          </LbInstruction>
          <LbInstruction>
            <Typography variant="body1" sx={{ marginBottom: (theme) => theme.spacing(2) }}>
              ご利用を検討中のお客様は、
              <br />
              こちらからお問い合わせください
            </Typography>
            <BtnSecondary variant="contained" disableRipple onClick={toSupportPage}>
              お問い合わせ
            </BtnSecondary>
          </LbInstruction>
        </LbContent>
      </GridContainer>
    </LoginLayout>
  )
}

export default ConcurLogin
